import React from 'react';
import { NavLink } from 'react-router-dom';

export const NotificationsIcon = () => {
    return (
        <div className="me-2">
            <NavLink to="/notifications" className="fa-2x">
                <span className="fa-layers fa-fw">
                    <i className="fal fa-bell" style={{ color: 'var(--bs-secondary)' }}></i>
                </span>
            </NavLink>
        </div>
    );
};
